
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-functions-as-helper-polyfill/-embroider-implicit-modules.js";
